import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-vyv-redirect",
  template: "",
})
export class RedirectComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
